<template>
<b-container fluid class="mt-80px">
    <div class="chartFilter">
        <select v-model="typeOfClient" class="">
            <option  value="">All</option>
            <option selected="selected" value="01">Contacts</option>
            <option value="03">People with HIV</option>
            <option value="04">Others</option>
        </select>
        <button class="btn btn_apply" @click="triggerFilter()">Apply</button>
    </div>
    <div class=" card choose-template-top-form p-0">
        <div class="card-header">
            Pathway
        </div>
        <div class="card-body" style="
            min-height: calc(100vh - 170px);
            overflow-y: auto;
        ">
            <div id='treecontainer' style="min-height: 450px"></div>
        </div>
    </div>
</b-container>
</template>

<style>
.node circle {
    fill: #fff;
    stroke: steelblue;
    stroke-width: 3px;
}

.node text {
    font-size: 14px
}

/*  .node--internal text {
      text-shadow: 0 1px 0 #fff, 0 -1px 0 #fff, 1px 0 0 #fff, -1px 0 0 #fff;
    }*/

.link {
    fill: none;
}

div.tooltip {
    position: absolute;
    text-align: center;
    width: 200px;
    padding: 8px;
    background: #3E3C3B;
    border: solid 1px #aaa;
    border-radius: 8px;
    pointer-events: none;
    color: #fff;
}

.pathwaytitle,
.pathwaydata {
    font-size: 14px;
    margin: 5px 0;
    color: #fff;
}
</style>

<script>
import ApiServices from '../service/ApiServices';
import * as d3 from "d3";
export default {
    name: "Pathway",
    components: {
        d3
    },
    data() {
        return {
            userData: JSON.parse(sessionStorage.getItem("userData")),
            fromDate: '',
            toDate: '',
            typeOfClient: '',
            indicatorObj: {
                "TB Pathway : Registered": 0,
                "TB Pathway : Screened": 0,
                "TB Pathway : Referred": 0,
                "TB Pathway : TPT initiated": 0,
                "TB Pathway : Tested": 0,
                "TB Pathway : Tested Positive": 0,
                "TPT Pathway : TPT initiated": 0,
                "TPT Pathway : Tested": 0,
                "TPT Pathway : Referred": 0,
                "TPT Pathway : Tested Positive": 0,
                "TPT Pathway : Registered": 0,
                "TPT Pathway : Screened": 0,
                "TPT Pathway : TPT completed":0
            },
            tree: {
                "name": "Registered",
                "data": 0,
                "children": [{
                    "name": "Screened",
                    "data": 0,
                    "children": [{
                            "name": "Referred for TBI",
                            "data": 0,
                            "children": [{
                                "name": "Tested for TBI",
                                "data": 0,
                                "children": [{
                                        "name": "Tested Positive",
                                        "data": 0,
                                        "children": [{
                                            "name": "TPT Started",
                                            "data": 0,
                                             "children": [{
                                                "name": "TPT Completed",
                                                "data": 0
                                            }]
                                        }]
                                    },
                                    {
                                        "name": "Tested Negative",
                                        "data":0
                                    },
                                ]
                            }]
                        },
                        {
                            "name": "Referred for TB",
                            "data": 0,
                            "color":'#4dcdc1',
                            "children": [{
                                "name": "Tested for TB",
                                "data": 0,
                                "color":'#4dcdc1',
                                "children": [{
                                        "name": "Tested Positive",
                                        "data": 0,
                                        "color":'#4dcdc1',
                                        "children": [{
                                            "name": "TB Treatment Started",
                                            "color":'#4dcdc1',
                                            "data": 0
                                        }]
                                    },
                                    {
                                        "name": "Tested Negative",
                                        "color":'#4dcdc1',
                                        "data": 0
                                    },
                                ]
                            }]
                        },
                    ]
                }]
            }
        }
    },
    methods: {
        triggerFilter() {
            this.getCustomIndicators(this.userData.orgid)
        },
        getCustomIndicators(param) {
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orguid": param,
                "role": this.userData.userrole,
                "language": "en",
                "fromdate": this.fromDate,
                "todate": this.toDate,
                "clienttype": this.typeOfClient
            }
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tb_dashboard_box_indicators', instance).then(res => {
                res.data.map(el => {
                    this.indicatorObj[el['indicatorname']] = el['count']
                })
                this.renderTreechart()
                this.$root.isLoading = false
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tpt_dashboard_box_indicators', instance).then(res => {
                res.data.map(el => {
                    this.indicatorObj[el['indicatorname']] = el['count']
                })
                this.renderTreechart()
                this.$root.isLoading = false
            })
            // console.log(this.indicatorObj)
        },
        renderTreechart() {
            this.tree.data = this.indicatorObj['TB Pathway : Registered']
            this.tree.children[0].data = this.indicatorObj['TB Pathway : Screened']

            this.tree.children[0].children[0].data = this.indicatorObj['TPT Pathway : Referred']
            this.tree.children[0].children[0].children[0].data = this.indicatorObj['TPT Pathway : Tested']
            this.tree.children[0].children[0].children[0].children[0].data = this.indicatorObj['TPT Pathway : Tested Positive']
            this.tree.children[0].children[0].children[0].children[0].children[0].data = this.indicatorObj['TPT Pathway : TPT initiated']
            this.tree.children[0].children[0].children[0].children[0].children[0].children[0].data = this.indicatorObj['TPT Pathway : TPT completed']
            this.tree.children[0].children[0].children[0].children[1].data = parseInt(this.indicatorObj['TPT Pathway : Tested']) -  parseInt(this.indicatorObj['TPT Pathway : Tested Positive'])

            this.tree.children[0].children[1].data = this.indicatorObj['TB Pathway : Referred']
            this.tree.children[0].children[1].children[0].data = this.indicatorObj['TB Pathway : Tested']
            this.tree.children[0].children[1].children[0].children[0].data = this.indicatorObj['TB Pathway : Tested Positive']
            this.tree.children[0].children[1].children[0].children[0].children[0].data = this.indicatorObj['TB Pathway : TPT initiated']
            this.tree.children[0].children[1].children[0].children[1].data = parseInt(this.indicatorObj['TB Pathway : Tested']) -  parseInt(this.indicatorObj['TB Pathway : Tested Positive'])

            // Set the dimensions and margins of the diagram
            document.getElementById('treecontainer').innerHTML = "";
            var margin = {
                    top: 20,
                    right: 50,
                    bottom: 30,
                    left: 50
                },
                width = document.getElementById('treecontainer').offsetWidth - margin.left - margin.right,
                height = 500 - margin.top - margin.bottom;
            var maxLabel = 150;
            var divider = 150;
            // console.log(divider)

            // append the svg object to the body of the page
            // appends a 'group' element to 'svg'
            // moves the 'group' element to the top left margin
            var svg = d3.select("#treecontainer").append("svg")
                //.attr("width", width)
                //.attr("height", height + margin.top + margin.bottom)
                .attr("viewBox", "0 0 1278 " + height)
                .attr("preserveAspectRatio", "xMidYMid meet")
                .append("g")
                .attr("transform", "translate(141.9059066772461,20)");

            // Add tooltip div
            var tooltip = d3.select("body").append("div")
                .attr("class", "tooltip")
                .style("opacity", 1e-6);

            var i = 0,
                duration = 750,
                root;

            // declares a tree layout and assigns the size
            var treemap = d3.tree().size([height, width]);

            // Assigns parent, children, height, depth
            root = d3.hierarchy(this.tree, function (d) {
                return d.children;
            });
            root.x0 = height / 2;
            root.y0 = 0;

            // Collapse after the second level
            //root.children.forEach(collapse);
            update(root);

            // Collapse the node and all it's children
            function collapse(d) {

                if (d.children) {
                    d._children = d.children
                    d._children.forEach(collapse)
                    d.children = null
                }
            }

            function update(source) {

                // Assigns the x and y position for the nodes
                var treeData = treemap(root);

                // Compute the new tree layout.
                var nodes = treeData.descendants(),
                    links = treeData.descendants().slice(1);

                // Normalize for fixed-depth.
                nodes.forEach(function (d) {
                    d.y = d.depth * divider
                });

                // ****************** Nodes section ***************************

                // Update the nodes...
                var node = svg.selectAll('g.node')
                    .data(nodes, function (d) {
                        return d.id || (d.id = ++i);
                    });

                // Enter any new modes at the parent's previous position.
                var nodeEnter = node.enter().append('g')
                    .attr('class', 'node')
                    .attr("transform", function (d) {
                        return "translate(" + source.y0 + "," + source.x0 + ")";
                    })
                    .on('click', click)
                    .on("mouseover", mouseover)
                    .on("mousemove", function (d) {
                        mousemove(d);
                    })
                    .on("mouseout", mouseout)

                function mouseover() {
                    tooltip.transition()
                        .duration(300)
                        .style("opacity", 1);
                }

                function mousemove(d) {
                    var html = '<div>'
                    html += '<div class="pathwaytitle">' + d.data.name + ' </div>'
                    html += '<div class="pathwaydata">Count: ' + d.data.data + '</div>'
                    html += '</div>'
                    tooltip.html(html)
                        .style("opacity", 1)
                        .style("left", (d3.event.pageX) + "px")
                        .style("top", (d3.event.pageY) + "px");

                }

                function mouseout() {
                    tooltip.transition()
                        .duration(300)
                        .style("opacity", 1e-6);
                }

                // Add Circle for the nodes
                nodeEnter.append('circle')
                    .attr('class', 'node')
                    .attr('r', 1e-6)
                    .style("stroke", function (d) {
                        return d.data.color;
                    })
                    .style("fill", function (d) {
                        return d.data.color
                    });

                // Add labels for the nodes
                var text = nodeEnter.append('text')
                    .attr("x", function (d) {
                        return d.children || d._children ? "40" : "20";
                    })
                    .attr("dy", function (d) {
                        return d.depth == 0 ? '-30' : d.children || d._children ? "-30" : "5";
                    })
                    .attr("text-anchor", function (d) {
                        return d.children || d._children ? "end" : "start";
                    })
                    .style('fill', '#000')
                    .text(function (d) {
                        return d.data.name;
                    });

                text.append("tspan")
                    .style("font-weight", function (d) {
                        return "bold";
                    })
                    .text(function (d) {
                        return ' (' + d.data.data + ')'
                    });

                // UPDATE
                var nodeUpdate = nodeEnter.merge(node);

                // Transition to the proper position for the node
                nodeUpdate.transition()
                    .duration(duration)
                    .attr("transform", function (d) {
                        return "translate(" + d.y + "," + d.x + ")";
                    });

                // Update the node attributes and style
                nodeUpdate.select('circle.node')
                    .attr('r', function (d) {
                        if (d.data != undefined) {
                            return 15
                        }
                    })
                    .style("stroke", function (d) {
                        return d.data.color || '#238cbb'
                    })
                    .style("fill", function (d) {
                        if (d.data != undefined) {
                            return d.data.color || '#238cbb'
                        }
                    })
                    .attr('cursor', 'pointer');

                // Remove any exiting nodes
                var nodeExit = node.exit().transition()
                    .duration(duration)
                    .attr("transform", function (d) {
                        return "translate(" + source.y + "," + source.x + ")";
                    })
                    .remove();

                // On exit reduce the node circles size to 0
                nodeExit.select('circle')
                    .attr('r', 1e-6);

                // On exit reduce the opacity of text labels
                nodeExit.select('text')
                    .style('fill-opacity', 1e-6);

                // ****************** links section ***************************

                // Update the links...
                var link = svg.selectAll('path.link')
                    .data(links, function (d) {
                        return d.id;
                    });

                // Enter any new links at the parent's previous position.
                var linkEnter = link.enter().insert('path', "g")
                    .attr("class", "link")
                    .attr("stroke-width", function (d) {
                        return 3;
                    })
                    .attr('d', function (d) {
                        var o = {
                            x: source.x0,
                            y: source.y0
                        }
                        return diagonal(o, o)
                    })
                    .attr("stroke", function (d) {
                        if (d.data != undefined) {
                            return d.data.color || '#a9a9a9'; //'#eee';
                        }
                    });

                // UPDATE
                var linkUpdate = linkEnter.merge(link);

                // Transition back to the parent element position
                linkUpdate.transition()
                    .duration(duration)
                    .attr('d', function (d) {
                        return diagonal(d, d.parent)
                    });

                // Remove any exiting links
                var linkExit = link.exit().transition()
                    .duration(duration)
                    .attr('d', function (d) {
                        var o = {
                            x: source.x,
                            y: source.y
                        }
                        return diagonal(o, o)
                    }).remove();

                // Store the old positions for transition.
                nodes.forEach(function (d) {
                    d.x0 = d.x;
                    d.y0 = d.y;
                });

                // Creates a curved (diagonal) path from parent to the child nodes
                function diagonal(s, d) {

                    return "M" + s.y + "," + s.x +
                        "C" + (s.y + d.y) / 2 + "," + s.x +
                        " " + (s.y + d.y) / 2 + "," + d.x +
                        " " + d.y + "," + d.x;

                }

                // Toggle children on click.
                function click(d) {
                    if (d.children) {
                        d._children = d.children;
                        d.children = null;
                    } else {
                        d.children = d._children;
                        d._children = null;
                    }
                    update(d);
                }
            }
        },
        mapDataRadius() {
            // console.log(this.tree.data)
            if (this.tree.data == 0) {
                this.minradius = 10
            }
            this.tree['radius'] = 10
            this.tree['color'] = '#03a9fb';
            this.getEachChildRadius(this.tree.children)
        },
        getEachChildRadius(children) {
            var arr = this.getminMax(children)
            var min = arr.length == 1 ? 0 : Math.min.apply(null, arr);
            var max = Math.max.apply(null, arr);
            children.forEach(obj => {
                var colo = this.colorObj.filter(q => q.name == obj.name)
                obj['radius'] = this.getCircleRadius(parseInt(obj.data), min, max)
                obj['color'] = colo.length > 0 ? colo[0]['color'] : '#2c6bb8'
                if (obj.children != undefined) {
                    this.getEachChildRadius(obj.children)
                }
            })
        },
        getminMax(children) {
            var arr = []
            children.forEach(obj => {
                arr.push(obj.data);
            })
            return arr;
        },
        getCircleRadius(val, min, max) {
            this.minnum = Math.min.apply(null, this.minnumbeArr);
            // Map a data property that ranges from 0 to 100 to a value between 5 and 20 (e.g. marker radius)
            var linearFunction = new L.LinearFunction(new L.Point(min, this.minradius), new L.Point(max, this.maxradius));
            return 10;
        },
        toast(toastType = 'success', message, title = 'Success', append = false) {
            this.$bvToast.toast(`${message}`, {
                title: `${title}`,
                variant: toastType,
                solid: true,
                appendToast: append,
                toaster: 'b-toaster-top-center'
            })
        }
    },
    mounted() {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        this.toDate = d.getFullYear() + '-' +
            (('' + month).length < 2 ? '0' : '') + month + '-' +
            (('' + day).length < 2 ? '0' : '') + day;
        this.fromDate = '2000-01-01'
        this.getCustomIndicators(this.userData.organisationUnits[0].id)
    }
}
</script>
